module.exports = __webpack_public_path__ + "img/ico_close.25e9f827.svg";